import React from 'react';
import { ROUTES } from './routes';

const DashboardPage              = React.lazy(() => import('./pages/DashboardPage'));
const RegulatoryChangesPage      = React.lazy(() => import('./pages/RegulatoryChangesPage'));
const BrokerProfileSetupPage     = React.lazy(() => import('./pages/BrokerProfileSetupPage'));
const SupervisionPage            = React.lazy(() => import('./pages/SupervisionPage'));
const CommunicationsPage         = React.lazy(() => import('./pages/CommunicationsPage'));
const InboundReviewPage          = React.lazy(() => import('./pages/InboundReviewPage'));
const CarrierPortalPage          = React.lazy(() => import('./pages/CarrierPortalPage'));
const RegulatoryIntelligencePage = React.lazy(() => import('./pages/RegulatoryIntelligencePage'));
const RegulatoryMapPage          = React.lazy(() => import('./pages/RegulatoryMapPage'));
const LicensingPage              = React.lazy(() => import('./pages/LicensingPage'));
const DocumentRepositoryPage     = React.lazy(() => import('./pages/DocumentRepositoryPage'));
const ComplianceCalendarPage     = React.lazy(() => import('./pages/ComplianceCalendarPage'));
const CETrackerPage              = React.lazy(() => import('./pages/CETrackerPage'));
const MFASetupPage               = React.lazy(() => import('./pages/MFASetupPage'));
const CPADashboardPage           = React.lazy(() => import('./pages/CPADashboardPage'));
const LawyerDashboardPage        = React.lazy(() => import('./pages/LawyerDashboardPage'));
const RegulatoryFilingsPage      = React.lazy(() => import('./pages/RegulatoryFilingsPage'));
const OnboardingHubPage          = React.lazy(() => import('./pages/OnboardingHubPage'));
const MyFirmsPage                = React.lazy(() => import('./pages/MyFirmsPage'));
const PBProfilePage              = React.lazy(() => import('./pages/PBProfilePage'));
const PBOnboardingPage           = React.lazy(() => import('./pages/PBOnboardingPage'));
const GovernanceMasterPage       = React.lazy(() => import('./pages/GovernanceMasterPage'));
const ComplaintsPage             = React.lazy(() => import('./pages/ComplaintsPage'));
const ComplianceQuestionsPage    = React.lazy(() => import('./pages/ComplianceQuestionsPage'));
const ComplianceAnswersPage      = React.lazy(() => import('./pages/ComplianceAnswersPage'));
const Form1Page                  = React.lazy(() => import('./pages/Form1Page'));
const AuditResponsePage          = React.lazy(() => import('./pages/AuditResponsePage'));
const LiabilityShieldPage        = React.lazy(() => import('./pages/LiabilityShieldPage'));
const ProfessionalDirectoryPage  = React.lazy(() => import('./pages/ProfessionalDirectoryPage'));
const FilingVaultPage            = React.lazy(() => import('./pages/FilingVaultPage'));
const BulkIngestReviewPage       = React.lazy(() => import('./pages/BulkIngestReviewPage'));
const FirmContactsPage           = React.lazy(() => import('./pages/FirmContactsPage'));
const RenewalsPage               = React.lazy(() => import('./pages/RenewalsPage'));
const CarrierIntakePage          = React.lazy(() => import('./pages/CarrierIntakePage'));
const DocumentIngestPage         = React.lazy(() => import('./pages/DocumentIngestPage'));
const CECourseFinderPage         = React.lazy(() => import('./pages/CECourseFinderPage'));
const RegulatorAccessPage        = React.lazy(() => import('./pages/RegulatorAccessPage'));
const MultiLicenceCEPage         = React.lazy(() => import('./pages/MultiLicenceCEPage'));
const LicenceWalletPage          = React.lazy(() => import('./pages/LicenceWalletPage'));
const LicenceChartImportPage     = React.lazy(() => import('./pages/LicenceChartImportPage'));
const IndustryEventsPage         = React.lazy(() => import('./pages/IndustryEventsPage'));
const ConferencesPage            = React.lazy(() => import('./pages/ConferencesPage'));
const HospitalityRegisterPage    = React.lazy(() => import('./pages/HospitalityRegisterPage'));
const BrokerReadinessDashboard   = React.lazy(() => import('./pages/BrokerReadinessDashboard'));
const BrokerDocumentVaultPage    = React.lazy(() => import('./pages/BrokerDocumentVaultPage'));
const ComplianceDeadlinePage     = React.lazy(() => import('./pages/ComplianceDeadlinePage'));
const NotificationHistoryPage    = React.lazy(() => import('./pages/NotificationHistoryPage'));
const AttestationsPage           = React.lazy(() => import('./pages/AttestationsPage'));
const PBAttestationsPage         = React.lazy(() => import('./pages/PBAttestationsPage'));
const CarrierAuditPage           = React.lazy(() => import('./pages/CarrierAuditPage'));
const AuditBinderPage            = React.lazy(() => import('./pages/AuditBinderPage'));
const BrokerCEUploadPage         = React.lazy(() => import('./pages/BrokerCEUploadPage'));
const BrokerLicenceUploadPage    = React.lazy(() => import('./pages/BrokerLicenceUploadPage'));
const BrokerCRCUploadPage        = React.lazy(() => import('./pages/BrokerCRCUploadPage'));
const BrokerDeclarationPage      = React.lazy(() => import('./pages/BrokerDeclarationPage'));
const PBReviewQueuePage          = React.lazy(() => import('./pages/PBReviewQueuePage'));
const EOTrackingPage             = React.lazy(() => import('./pages/EOTrackingPage'));
const RoleManagementPage         = React.lazy(() => import('./pages/RoleManagementPage'));
const BrokerProfilePage          = React.lazy(() => import('./pages/BrokerProfilePage'));
const BrokerDashboardPage        = React.lazy(() => import('./pages/BrokerDashboardPage'));
const CarrierAppointmentsPage    = React.lazy(() => import('./pages/CarrierAppointmentsPage'));
const MySupervisionPage          = React.lazy(() => import('./pages/MySupervisionPage'));
const FirmAdminDashboard         = React.lazy(() => import('./pages/FirmAdminDashboard'));
const FirmOnboardingPage         = React.lazy(() => import('./pages/FirmOnboardingPage'));
const MGADashboardPage           = React.lazy(() => import('./pages/MGADashboardPage'));
const FactFinderLaunchPage       = React.lazy(() => import('./pages/FactFinderLaunchPage'));
const SelfAssessmentPage         = React.lazy(() => import('./pages/SelfAssessmentPage'));
const NetworkDashboardPage       = React.lazy(() => import('./pages/NetworkDashboardPage'));
const RiboEoWorkflowPage         = React.lazy(() => import('./pages/RiboEoWorkflowPage'));
const FirmContactsModulePage     = React.lazy(() => import('./pages/FirmContactsModulePage'));
const AuditCentrePage            = React.lazy(() => import('./pages/AuditCentrePage'));
const JurisdictionStatementPage  = React.lazy(() => import('./pages/JurisdictionStatementPage'));
const CAMGAPipelinePage          = React.lazy(() => import('./pages/CAMGAPipelinePage'));
const FactFinderReviewPage       = React.lazy(() => import('./pages/FactFinderReviewPage'));
const PBDashboardPage            = React.lazy(() => import('./pages/PBDashboardPage'));
const PBBrokerOverviewPage       = React.lazy(() => import('./pages/PBBrokerOverviewPage'));
const RegulatoryReferencePage    = React.lazy(() => import('./pages/RegulatoryReferencePage'));
const ABRenewalQuestionnairePage           = React.lazy(() => import('./pages/ABRenewalQuestionnairePage'));
const CorporateRegistrationCalendarPage    = React.lazy(() => import('./pages/CorporateRegistrationCalendarPage'));

const PB = ['principal_broker', 'deputy_pb'];

/**
 * ROUTE_REGISTRY — single source of truth for all protected (non-public,
 * non-super-admin) routes. Each entry drives both the <Route> definition
 * in App.js and (eventually) sidebar/nav generation.
 *
 * allowedRoles: null  → any authenticated user
 * allowedRoles: [...]  → restricted to listed role strings
 *
 * Dynamic-segment paths (/governance/:firmId etc.) use string literals
 * because ROUTES constants represent navigable destinations, not patterns.
 */
export const ROUTE_REGISTRY = [

  // ── PB Dashboard (default landing for principal_broker / deputy_pb) ────────

  {
    path:         ROUTES.PB_DASHBOARD,
    label:        'PB Dashboard',
    element:      <PBDashboardPage />,
    allowedRoles: ['principal_broker', 'deputy_pb'],
    navSection:   'MY WORK',
    showInSidebar: true,
  },

  // ── PB Broker Management ──────────────────────────────────────────────────

  {
    path:          '/pb-broker-management',
    label:         'Broker Management',
    element:       <PBBrokerOverviewPage />,
    allowedRoles:  ['principal_broker', 'deputy_pb'],
    navSection:    'MY WORK',
    showInSidebar: false,
  },

  // ── Core (all authenticated roles) ────────────────────────────────────────

  {
    path:         ROUTES.DASHBOARD,
    label:        'Dashboard',
    element:      <DashboardPage />,
    allowedRoles: null,
    navSection:   'Core',
    showInSidebar: true,
  },
  {
    path:         ROUTES.REGULATORY_CHANGES,
    label:        'Regulatory Changes',
    element:      <RegulatoryChangesPage />,
    allowedRoles: null,
    navSection:   'Compliance',
    showInSidebar: true,
  },
  {
    path:         ROUTES.SUPERVISION,
    label:        'Supervision',
    element:      <SupervisionPage />,
    allowedRoles: ['principal_broker', 'deputy_pb', 'firm_admin'],
    navSection:   'Compliance',
    showInSidebar: true,
  },
  {
    path:         ROUTES.LICENSING,
    label:        'Licensing',
    element:      <LicensingPage />,
    allowedRoles: null,
    navSection:   'Compliance',
    showInSidebar: true,
  },
  {
    path:         ROUTES.COMPLIANCE_CALENDAR,
    label:        'Compliance Calendar',
    element:      <ComplianceCalendarPage />,
    allowedRoles: null,
    navSection:   'Compliance',
    showInSidebar: true,
  },
  {
    path:         ROUTES.CE_TRACKER,
    label:        'CE Tracker',
    element:      <CETrackerPage />,
    allowedRoles: null,
    navSection:   'Compliance',
    showInSidebar: true,
  },
  {
    path:         ROUTES.CE_COURSES,
    label:        'CE Course Finder',
    element:      <CECourseFinderPage />,
    allowedRoles: ['broker', 'principal_broker', 'deputy_pb', 'mga'],
    navSection:   'Compliance',
    showInSidebar: false,
  },
  {
    path:         ROUTES.REGULATOR_ACCESS,
    label:        'Regulator Access',
    element:      <RegulatorAccessPage />,
    allowedRoles: ['broker', 'principal_broker', 'deputy_pb', 'mga'],
    navSection:   'Intelligence',
    showInSidebar: true,
  },
  {
    path:         ROUTES.MULTI_LICENCE_CE,
    label:        'Multi-Licence CE',
    element:      <MultiLicenceCEPage />,
    allowedRoles: ['broker', 'principal_broker', 'deputy_pb', 'mga'],
    navSection:   'Compliance',
    showInSidebar: false,
  },
  {
    path:         ROUTES.LICENCE_WALLET,
    label:        'Licence Wallet',
    element:      <LicenceWalletPage />,
    allowedRoles: ['broker', 'principal_broker', 'deputy_pb', 'mga'],
    navSection:   'Compliance',
    showInSidebar: true,
  },
  {
    // Licence chart import (2026-11-01): the backend returns 404 while
    // LICENCE_CHART_IMPORT_ENABLED is off, and the page says so.
    path:         ROUTES.LICENCE_CHART_IMPORT,
    label:        'Import licence chart',
    element:      <LicenceChartImportPage />,
    allowedRoles: ['principal_broker', 'deputy_pb'],
    navSection:   'Compliance',
    showInSidebar: false,
  },
  {
    path:         ROUTES.INDUSTRY_EVENTS,
    label:        'Industry Events',
    element:      <IndustryEventsPage />,
    allowedRoles: ['broker', 'principal_broker', 'deputy_pb', 'mga'],
    navSection:   'Intelligence',
    showInSidebar: true,
  },
  {
    path:         ROUTES.BROKER_READINESS,
    label:        'Readiness Dashboard',
    element:      <BrokerReadinessDashboard />,
    allowedRoles: ['broker', 'principal_broker', 'deputy_pb', 'mga'],
    navSection:   'Compliance',
    showInSidebar: false,
  },
  {
    path:         ROUTES.BROKER_DOCUMENTS,
    label:        'My Documents',
    element:      <BrokerDocumentVaultPage />,
    allowedRoles: ['broker', 'principal_broker', 'deputy_pb'],
    navSection:   'Compliance',
    showInSidebar: false,
  },
  {
    path:         ROUTES.BROKER_DEADLINES,
    label:        'Deadline Calendar',
    element:      <ComplianceDeadlinePage />,
    allowedRoles: ['broker', 'principal_broker', 'deputy_pb', 'mga'],
    navSection:   'Compliance',
    showInSidebar: false,
  },
  {
    path:         ROUTES.NOTIFICATION_HISTORY,
    label:        'Notifications',
    element:      <NotificationHistoryPage />,
    allowedRoles: null,
    navSection:   'Compliance',
    showInSidebar: false,
  },
  {
    path:         ROUTES.ATTESTATIONS,
    label:        'Attestations',
    element:      <AttestationsPage />,
    allowedRoles: ['broker', 'deputy_pb', 'principal_broker', 'mga'],
    navSection:   'Compliance',
    showInSidebar: true,
  },
  {
    path:         ROUTES.ADMIN_ATTESTATIONS,
    label:        'Manage Attestations',
    element:      <PBAttestationsPage />,
    allowedRoles: ['principal_broker', 'deputy_pb'],
    navSection:   'Principal Broker',
    showInSidebar: true,
  },
  {
    path:         ROUTES.MY_FIRMS,
    label:        'My Firms',
    element:      <MyFirmsPage />,
    allowedRoles: ['principal_broker', 'deputy_pb'],
    navSection:   'Core',
    showInSidebar: true,
  },
  {
    path:         ROUTES.NETWORK_DASHBOARD,
    label:        'Network Dashboard',
    element:      <NetworkDashboardPage />,
    allowedRoles: ['principal_broker', 'deputy_pb'],
    navSection:   'Core',
    showInSidebar: true,
  },
  {
    path:         ROUTES.COMMUNICATIONS,
    label:        'Communications',
    element:      <CommunicationsPage />,
    allowedRoles: null,
    navSection:   'Tools',
    showInSidebar: true,
  },
  {
    // Inbound client email filed to a firm, waiting for PB review (Task 5).
    // The API (routes/inboundReview.js) is PB and Deputy PB only too.
    path:         ROUTES.INBOUND_REVIEW,
    label:        'Inbound for review',
    element:      <InboundReviewPage />,
    allowedRoles: ['principal_broker', 'deputy_pb'],
    navSection:   'Tools',
    showInSidebar: true,
  },
  {
    path:         ROUTES.CARRIER_PORTAL,
    label:        'Carrier Portal',
    element:      <CarrierPortalPage />,
    allowedRoles: ['carrier', 'mga'],
    navSection:   'Tools',
    showInSidebar: true,
  },
  {
    path:         ROUTES.REGULATORY_INTELLIGENCE,
    label:        'Regulatory Intelligence',
    element:      <RegulatoryIntelligencePage />,
    allowedRoles: null,
    navSection:   'Intelligence',
    showInSidebar: true,
  },
  {
    path:         ROUTES.REGULATORY_MAP,
    label:        'Regulatory Map',
    element:      <RegulatoryMapPage />,
    allowedRoles: null,
    navSection:   'Intelligence',
    showInSidebar: true,
  },
  {
    path:         ROUTES.DOCUMENT_REPOSITORY,
    label:        'Document Repository',
    element:      <DocumentRepositoryPage />,
    allowedRoles: null,
    navSection:   'Tools',
    showInSidebar: false,
  },
  {
    path:         ROUTES.REGULATORY_FILINGS,
    label:        'Regulatory Filings',
    element:      <RegulatoryFilingsPage />,
    allowedRoles: ['principal_broker', 'deputy_pb', 'firm_admin', 'lawyer'],
    navSection:   'Tools',
    showInSidebar: false,
  },
  {
    path:         ROUTES.ONBOARDING_HUB,
    label:        'Onboarding Hub',
    element:      <OnboardingHubPage />,
    allowedRoles: null,
    navSection:   'Tools',
    showInSidebar: false,
  },

  // ── Account (not in sidebar) ───────────────────────────────────────────────

  {
    path:         ROUTES.PROFILE_SETUP,
    label:        'Profile Setup',
    element:      <BrokerProfileSetupPage />,
    allowedRoles: null,
    navSection:   'Account',
    showInSidebar: false,
  },
  {
    path:         ROUTES.MFA_SETUP,
    label:        'MFA Setup',
    element:      <MFASetupPage />,
    allowedRoles: null,
    navSection:   'Account',
    showInSidebar: false,
  },

  // ── Role-specific dashboards ───────────────────────────────────────────────

  {
    path:         ROUTES.CPA_DASHBOARD,
    label:        'CPA Dashboard',
    element:      <CPADashboardPage />,
    allowedRoles: ['cpa'],
    navSection:   'Core',
    showInSidebar: true,
  },
  {
    path:         '/trust-accounts',
    label:        'Trust Accounts',
    element:      <CPADashboardPage />,
    allowedRoles: ['cpa'],
    navSection:   'Core',
    showInSidebar: false,
  },
  {
    path:         '/reports',
    label:        'Reports',
    element:      <CPADashboardPage />,
    allowedRoles: ['cpa'],
    navSection:   'Core',
    showInSidebar: false,
  },
  {
    path:         ROUTES.LAWYER_DASHBOARD,
    label:        'Lawyer Dashboard',
    element:      <LawyerDashboardPage />,
    allowedRoles: ['lawyer'],
    navSection:   'Core',
    showInSidebar: true,
  },

  // ── Principal Broker only ──────────────────────────────────────────────────

  {
    path:         ROUTES.AUDIT_BINDER,
    label:        'Compliance Binder',
    element:      <AuditBinderPage />,
    allowedRoles: [...PB, 'firm_admin', 'mga'],
    navSection:   'Principal Broker',
    showInSidebar: true,
  },
  {
    path:         ROUTES.RENEWALS,
    label:        'Licence Renewals',
    element:      <RenewalsPage />,
    allowedRoles: PB,
    navSection:   'Tools',
    showInSidebar: true,
  },
  {
    // BUG FIX: backend (routes/carrier-intake.js) already lets a carrier user
    // upload directly (`uRole(req) !== 'carrier'` check) and review/approve
    // items via carrierAccessControl.js's per-item permission grants — this
    // route guard was PB-only, so a carrier landing here via a shared/direct
    // link was blocked by the frontend before ever reaching that backend logic.
    path:         ROUTES.CARRIER_INTAKE,
    label:        'Carrier Document Intake',
    element:      <CarrierIntakePage />,
    allowedRoles: [...PB, 'carrier'],
    navSection:   'Tools',
    showInSidebar: true,
  },
  {
    path:         ROUTES.CARRIER_AUDITS,
    label:        'Carrier Audits',
    element:      <CarrierAuditPage />,
    allowedRoles: PB,
    navSection:   'Tools',
    showInSidebar: true,
    badgeKey:     'carrierAudits',
  },
  {
    path:         ROUTES.PB_PROFILE,
    label:        'My Profile',
    element:      <PBProfilePage />,
    allowedRoles: PB,
    navSection:   'Principal Broker',
    showInSidebar: true,
  },
  {
    path:         ROUTES.PB_ONBOARDING,
    label:        'PB Onboarding',
    element:      <PBOnboardingPage />,
    allowedRoles: PB,
    navSection:   'Principal Broker',
    showInSidebar: false,
  },
  {
    path:         ROUTES.COMPLAINTS,
    label:        'Complaints',
    element:      <ComplaintsPage />,
    // Complaint cases are for the firm's PB and Deputy PB only (2026-11-04).
    allowedRoles: [...PB],
    navSection:   'Tools',
    showInSidebar: true,
  },
  {
    path:         ROUTES.COMPLIANCE_QUESTIONS,
    label:        'Compliance Questions',
    element:      <ComplianceQuestionsPage />,
    allowedRoles: [...PB, 'firm_admin', 'mga', 'lawyer'],
    navSection:   'Compliance',
    showInSidebar: true,
  },
  {
    path:         ROUTES.COMPLIANCE_ANSWERS,
    label:        'Compliance Answers',
    element:      <ComplianceAnswersPage />,
    allowedRoles: [...PB, 'firm_admin', 'mga', 'carrier'],
    navSection:   'Compliance',
    showInSidebar: true,
  },
  {
    path:         ROUTES.FORM1,
    label:        'Trust Position Report',
    element:      <Form1Page />,
    allowedRoles: [...PB, 'firm_admin', 'cpa'],
    navSection:   'Tools',
    showInSidebar: true,
  },
  {
    path:         ROUTES.FILING_VAULT,
    label:        'Filing Vault',
    element:      <FilingVaultPage />,
    allowedRoles: PB,
    navSection:   'Tools',
    showInSidebar: true,
  },
  {
    path:         ROUTES.AUDIT_RESPONSE,
    label:        'Audit Response',
    element:      <AuditResponsePage />,
    allowedRoles: [...PB, 'lawyer'],
    navSection:   'Tools',
    showInSidebar: true,
  },
  {
    path:         ROUTES.LIABILITY_SHIELD,
    label:        'Liability Shield',
    element:      <LiabilityShieldPage />,
    allowedRoles: [...PB, 'lawyer'],
    navSection:   'Principal Broker',
    showInSidebar: true,
  },
  {
    path:         ROUTES.PROFESSIONAL_DIRECTORY,
    label:        'Professional Directory',
    element:      <ProfessionalDirectoryPage />,
    allowedRoles: PB,
    navSection:   'Principal Broker',
    showInSidebar: false,
  },

  // Dynamic-segment routes (not in sidebar — destination varies by param)
  {
    path:         '/governance/:firmId',
    label:        'Governance',
    element:      <GovernanceMasterPage />,
    allowedRoles: [...PB, 'firm_admin', 'mga', 'lawyer'],
    navSection:   'Principal Broker',
    showInSidebar: false,
  },
  {
    path:         '/filing-vault/review/:batchId',
    label:        'Bulk Ingest Review',
    element:      <BulkIngestReviewPage />,
    allowedRoles: PB,
    navSection:   'Principal Broker',
    showInSidebar: false,
  },
  {
    path:         '/firms/:firmId/contacts',
    label:        'Firm Contacts',
    element:      <FirmContactsPage />,
    allowedRoles: PB,
    navSection:   'Principal Broker',
    showInSidebar: false,
  },
  {
    path:         '/firms/:firmId/documents',
    label:        'Document Ingestion',
    element:      <DocumentIngestPage />,
    allowedRoles: ['principal_broker', 'deputy_pb', 'firm_admin', 'mga', 'lawyer'],
    navSection:   'Principal Broker',
    showInSidebar: false,
  },

  // ── Broker Self-Service ────────────────────────────────────────────────────
  {
    path:         ROUTES.BROKER_CE_UPLOAD,
    label:        'Upload CE Certificate',
    element:      <BrokerCEUploadPage />,
    allowedRoles: ['broker', 'principal_broker', 'deputy_pb'],
    navSection:   'Broker Self-Service',
    showInSidebar: false,
  },
  {
    path:         ROUTES.BROKER_LICENCE_UPLOAD,
    label:        'Upload Licence',
    element:      <BrokerLicenceUploadPage />,
    allowedRoles: ['broker', 'principal_broker', 'deputy_pb'],
    navSection:   'Broker Self-Service',
    showInSidebar: false,
  },
  {
    path:         ROUTES.BROKER_CRC_UPLOAD,
    label:        'Upload CRC',
    element:      <BrokerCRCUploadPage />,
    allowedRoles: ['broker', 'principal_broker', 'deputy_pb'],
    navSection:   'Broker Self-Service',
    showInSidebar: false,
  },
  {
    path:         ROUTES.BROKER_DECLARATION,
    label:        'Annual Declaration',
    element:      <BrokerDeclarationPage />,
    allowedRoles: ['broker', 'principal_broker', 'deputy_pb'],
    navSection:   'Broker Self-Service',
    showInSidebar: false,
  },

  // ── PB Review Queue ────────────────────────────────────────────────────────
  {
    path:         ROUTES.PB_REVIEW_QUEUE,
    label:        'Review Queue',
    element:      <PBReviewQueuePage />,
    allowedRoles: PB,
    navSection:   'Principal Broker',
    showInSidebar: true,
  },

  // ── E&O Tracking ───────────────────────────────────────────────────────────
  {
    path:         ROUTES.EO_TRACKING,
    label:        'E&O Tracking',
    element:      <EOTrackingPage />,
    allowedRoles: [...PB, 'mga'],
    navSection:   'Tools',
    showInSidebar: true,
  },

  // ── Role Management ─────────────────────────────────────────────────────────
  {
    path:         ROUTES.ROLE_MANAGEMENT,
    label:        'Role Management',
    element:      <RoleManagementPage />,
    allowedRoles: [...PB, 'firm_admin'],
    navSection:   'Principal Broker',
    showInSidebar: true,
  },

  // ── Broker-specific pages ────────────────────────────────────────────────────
  {
    path:         ROUTES.BROKER_DASHBOARD,
    label:        'My Dashboard',
    element:      <BrokerDashboardPage />,
    allowedRoles: ['broker'],
    navSection:   'Broker',
    showInSidebar: false,
  },
  {
    path:         ROUTES.BROKER_ATTESTATIONS,
    label:        'My Attestations',
    element:      <AttestationsPage />,
    allowedRoles: ['broker', 'principal_broker', 'deputy_pb', 'mga'],
    navSection:   'Broker',
    showInSidebar: false,
  },
  {
    path:         ROUTES.CARRIER_APPOINTMENTS,
    label:        'My Appointments',
    element:      <CarrierAppointmentsPage />,
    allowedRoles: ['broker', 'principal_broker', 'deputy_pb'],
    navSection:   'Broker',
    showInSidebar: false,
  },
  {
    path:         ROUTES.MY_SUPERVISION,
    label:        'My Supervision',
    element:      <MySupervisionPage />,
    allowedRoles: ['broker', 'principal_broker', 'deputy_pb'],
    navSection:   'Broker',
    showInSidebar: false,
  },
  {
    path:         ROUTES.BROKER_PROFILE,
    label:        'My Profile',
    element:      <BrokerProfilePage />,
    allowedRoles: ['broker', 'principal_broker', 'deputy_pb', 'firm_admin'],
    navSection:   'Broker',
    showInSidebar: false,
  },
  {
    path:         ROUTES.DEADLINES,
    label:        'Deadlines',
    element:      <ComplianceDeadlinePage />,
    allowedRoles: ['broker', 'principal_broker', 'deputy_pb', 'mga'],
    navSection:   'Broker',
    showInSidebar: false,
  },

  // ── MGA Dashboard ─────────────────────────────────────────────────────────────
  {
    path:         ROUTES.MGA_DASHBOARD,
    label:        'My Dashboard',
    element:      <MGADashboardPage />,
    allowedRoles: ['mga'],
    navSection:   'MGA',
    showInSidebar: true,
  },
  {
    path:         '/mga-fact-finder',
    label:        'MGA Fact Finder',
    element:      <FactFinderLaunchPage />,
    allowedRoles: ['mga', 'firm_admin'],
    navSection:   'MGA',
    showInSidebar: false,
  },
  {
    path:         '/self-assessment',
    label:        'Self-Assessment',
    element:      <SelfAssessmentPage />,
    allowedRoles: [...PB, 'firm_admin', 'mga'],
    navSection:   'MGA',
    showInSidebar: false,
  },
  {
    path:         '/documents',
    label:        'Documents',
    element:      <DocumentRepositoryPage />,
    allowedRoles: null,
    navSection:   'MGA',
    showInSidebar: false,
  },

  // ── RIBO E&O / Fidelity Bond Renewal Workflow ─────────────────────────────────
  {
    path:         ROUTES.RIBO_EO,
    label:        'RIBO E&O Renewal',
    element:      <RiboEoWorkflowPage />,
    allowedRoles: ['principal_broker', 'deputy_pb', 'firm_admin'],
    navSection:   'Compliance',
    showInSidebar: false,
  },

  // ── Audit Centre ─────────────────────────────────────────────────────────────
  {
    path:         '/audit-centre',
    label:        'Audit Centre',
    element:      <AuditCentrePage />,
    allowedRoles: ['principal_broker', 'deputy_pb', 'firm_admin', 'carrier'],
    navSection:   'Compliance',
    showInSidebar: true,
  },

  // ── Jurisdiction Statements of Compliance ─────────────────────────────────────
  {
    path:         ROUTES.JURISDICTION_STATEMENTS,
    label:        'Jurisdiction Statements',
    element:      <JurisdictionStatementPage />,
    allowedRoles: ['principal_broker', 'deputy_pb'],
    navSection:   'Compliance',
    showInSidebar: true,
  },

  // ── CAMGA Pipeline ────────────────────────────────────────────────────────────
  {
    path:         ROUTES.CAMGA_PIPELINE,
    label:        'CAMGA Pipeline',
    element:      <CAMGAPipelinePage />,
    allowedRoles: ['principal_broker'],
    superAdminOnly: true, // batch H (H1): the API is super admin only too
    navSection:   'Core',
    showInSidebar: true,
  },

  // ── AB AIC Annual Declaration Questionnaire ───────────────────────────────────
  {
    path:         '/ab-renewal-questionnaire',
    label:        'AB AIC Declaration',
    element:      <ABRenewalQuestionnairePage />,
    allowedRoles: PB,
    navSection:   'Principal Broker',
    showInSidebar: false,
  },

  // ── Corporate Registration Calendar ──────────────────────────────────────────
  {
    path:          '/corporate-registrations',
    label:         'Corp. Registrations',
    element:       <CorporateRegistrationCalendarPage />,
    allowedRoles:  ['principal_broker', 'deputy_pb', 'firm_admin'],
    navSection:    'Principal Broker',
    showInSidebar: true,
  },

  // ── Fact Finder Review (PB) ───────────────────────────────────────────────────
  {
    path:         '/fact-finder-review/:firmId',
    label:        'Fact Finder Review',
    element:      <FactFinderReviewPage />,
    allowedRoles: ['principal_broker', 'deputy_pb'],
    navSection:   'Principal Broker',
    showInSidebar: false,
  },

  // ── Firm Admin ────────────────────────────────────────────────────────────────
  {
    path:         '/firm-dashboard',
    label:        'My Firm Dashboard',
    element:      <FirmAdminDashboard />,
    allowedRoles: ['firm_admin'],
    navSection:   'Firm Admin',
    showInSidebar: true,
  },
  {
    path:         '/firm-contacts',
    label:        'Contacts',
    element:      <FirmContactsPage />,
    allowedRoles: ['firm_admin', 'principal_broker', 'deputy_pb'],
    navSection:   'Firm Admin',
    showInSidebar: false,
  },
  {
    path:         '/firm-contacts/:firmId',
    label:        'Contacts & Personnel',
    element:      <FirmContactsModulePage />,
    allowedRoles: ['principal_broker', 'deputy_pb', 'firm_admin', 'lawyer', 'cpa'],
    navSection:   'Compliance',
    showInSidebar: false,
  },
  {
    path:         '/firm-onboarding/:firmId',
    label:        'Firm Onboarding',
    element:      <FirmOnboardingPage />,
    allowedRoles: ['principal_broker', 'deputy_pb', 'mga', 'firm_admin'],
    navSection:   'Firm Admin',
    showInSidebar: false,
  },
  {
    path:         '/regulatory-reference',
    label:        'Regulatory Reference',
    element:      <RegulatoryReferencePage />,
    allowedRoles: ['principal_broker', 'deputy_pb', 'firm_admin'],
    navSection:   'Principal Broker',
    showInSidebar: true,
  },
  {
    // MGA conference/trade-show calendar — distinct from the CE Course
    // Finder's own "Industry Events" page at ROUTES.INDUSTRY_EVENTS.
    // Readable by every role (allowedRoles: null). navSection/showInSidebar
    // are unused here in practice: every role's sidebar, including PB and
    // deputy_pb's (getPBNav in Layout.js), is a hardcoded array, not
    // registry-driven (buildNavFromRegistry exists but nothing calls it) —
    // the actual nav entries for every role live in Layout.js.
    path:         ROUTES.CONFERENCES,
    label:        'Conferences',
    element:      <ConferencesPage />,
    allowedRoles: null,
    navSection:   'Intelligence',
    showInSidebar: true,
  },
  {
    path:         ROUTES.HOSPITALITY_REGISTER,
    label:        'Hospitality Register',
    element:      <HospitalityRegisterPage />,
    allowedRoles: null,
    navSection:   'Compliance',
    showInSidebar: true,
  },
];
